import script from "./OnboardingSlide1.vue?vue&type=script&setup=true&lang=js"
export * from "./OnboardingSlide1.vue?vue&type=script&setup=true&lang=js"

import "./OnboardingSlide1.vue?vue&type=style&index=0&id=17b3d949&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17b3d949"]])

export default __exports__